module.exports = __webpack_public_path__ + "img/1.75ed65d5.svg";